console.log('app.js');

gsap.registerPlugin(ScrollTrigger);

const splitTypes = document.querySelectorAll(
  '#adventure .content-text p, #fantasy .content-text p'
);

splitTypes.forEach((char, i) => {
  const split = new SplitType(char, { type: 'chars' });
  const chars = split.chars;

  gsap.from(chars, {
    y: 50,
    opacity: 0,
    stagger: 0.05,
    scrollTrigger: {
      trigger: char,
      start: 'top 80%',
      end: 'bottom 50%',
      scrub: true,
    },
  });
});

const lenis = new Lenis();

lenis.on('scroll', (e) => {
  // console.log('scroll', e);
});

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

const container = document.querySelector('.h-container');
const sections = gsap.utils.toArray('.h-container > div');
const texts = gsap.utils.toArray('.anim');

let scrollTween = gsap.to(sections, {
  xPercent: -100 * (sections.length - 1),
  ease: 'none',
  scrollTrigger: {
    trigger: container,
    pin: true,
    scrub: 1,
    // snap: 1 / (sections.length - 1),
    end: () => '+=' + container.offsetWidth,
    // end: '+=3000',
  },
});

// AGE VERIFICATION
// create a function that creates a cookie with a given name and value and expiration date
function setCookie(name, value, days) {
  let expires = '';
  if (days) {
    let date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + value + expires + '; path=/';
}

// create a function that reads the cookie with a given name
function getCookie(name) {
  let nameEQ = name + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

// create a function that erases the cookie with a given name
function eraseCookie(name) {
  document.cookie = name + '=; Max-Age=-99999999;';
}

// create a function that checks if the cookie with a given name exists
function checkCookie(name) {
  return getCookie(name) !== null;
}

if (!checkCookie('age-verified')) {
  // if the cookie doesn't exist, show the age verification popup
  console.log('show age verification popup');

  // document.querySelector('html').classList.add('no-scroll');
  const html = document.querySelector('body');
  html.style.overflow = 'hidden';
  html.style.position = 'fixed';
  html.style.maxHeight = '100vh';
  document.querySelector('.age-modal').style.display = 'flex';
}

document.querySelector('.close-age-popup').addEventListener('click', () => {
  setCookie('age-verified', 'true', 1);
  // const html = document.querySelector('html').classList.remove('no-scroll');
  const html = document.querySelector('body');
  html.style.overflow = 'initial';
  html.style.position = 'static';
  html.style.maxHeight = 'unset';
  document.querySelector('.age-modal').style.display = 'none';
});
